import React from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormGroup, Label, Input, Form, Row, Col, Button, NavLink, FormFeedback } from 'reactstrap';
import imagenfondo from '../assets/img/backgroundeSalarium.png';
import animacion from '../assets/img/eSalariumanima.png';
import infografia from '../assets/img/InfografiaEsalariumFinal.png';
import ok from '../assets/img/ok.png';
import nok from '../assets/img/nok.png';
import logo from '../assets/img/esalariumlogo.png';
import GoogleButton from 'react-google-button';
import { Collapse } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Spinner from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import FormCheck from 'react-bootstrap/FormCheck';
import { AiFillFile, AiFillFilePdf } from "react-icons/ai";
import YouTube from 'react-youtube';
import { unregister } from "../Interceptor.js";
import { Lightbox } from "react-modal-image";

//npm install --save react-script-tag
import ScriptTag from 'react-script-tag';

import { useLocation } from "react-router-dom";

var dataPaises = [{}];
var dataDepartamentos = [{}];
var dataCiudades = [{}];


//const arr = []

//export default async (req, res) => {
//    const {
//        method,
//        body
//    } = req
//    if (method === 'POST') {
//        res.statusCode = 200

//        res.setHeader('Content-Type', 'application/json')
//        res.end(JSON.stringify({
//            'msg': body,

//        }))
//        arr.push(JSON.stringify({
//            body
//        }))
//        //console.log(arr);
//    } else {
//        res.status(200).json(arr)
//    }
//}

export default function Login(props) {

    const eBillPay = useLocation().search;
    const token = new URLSearchParams(eBillPay).get('ref_payco');
    //console.log(token);
    const [respuestaPay, setrespuestaPay] = React.useState(false);
    const [respuestaPayStr, setrespuestaPayStr] = React.useState(false);
    const [logged, setlogged] = React.useState(false);

    const [imageView, setImageView] = React.useState(true);

    const opts = {
        height: '390',
        width: '640',
        playerVars: {
            // https://developers.google.com/youtube/player_parameters
            autoplay: 1,
        },
    };
    const [apiRoot, setapiRoot] = React.useState('https://esalariumprdweb.facturaenlinea.co/admin/Login');
    const [ocultaBotones, setocultaBotones] = React.useState(true);
    const [newNit, setnewNit] = React.useState("");
    const [newDv, setnewDv] = React.useState("");
    const [newRazonSocial, setnewRazonSocial] = React.useState("");
    const [newNombres, setnewNombres] = React.useState("");
    const [newApellidos, setnewApellidos] = React.useState("");
    const [newCorreo, setnewCorreo] = React.useState("");
    const [newCupon, setnewCupon] = React.useState("");
    const [newTyC, setnewTyC] = React.useState(false);
    const [newTdp, setnewTdp] = React.useState(false);
    const [basico, setbasico] = React.useState("198.000.00");
    const [avanzado, setavanzado] = React.useState("$300.000.00");
    const [basicostr, setbasicostr] = React.useState("198000");
    const [avanzadostr, setavanzadostr] = React.useState("300000");
    const [tieneDescuento, settieneDescuento] = React.useState(false);

    useEffect(() => {
        localStorage.clear();
        setocultaBotones(formValidation());

        localStorage.removeItem("token");
        const MuiDrawer = document.querySelector(".sidebar");
        if (MuiDrawer != undefined && MuiDrawer != null)
            MuiDrawer.parentNode.removeChild(MuiDrawer);
        const MuiPaper = document.querySelector(".navbar-absolute");
        if (MuiPaper != undefined && MuiPaper != null)
            MuiPaper.parentNode.removeChild(MuiPaper);
        const MuiFooter = document.querySelector(".footer");
        if (MuiFooter != undefined && MuiFooter != null)
            MuiFooter.parentNode.removeChild(MuiFooter);
        selectDataPaisesLoad();
        selectDataDepartamentosLoad(44);
        selectDataCiudadesLoad(5);
        localStorage.setItem('newPais', 1);
        localStorage.setItem('newDepartamento', 44);
        localStorage.setItem('newMunicipio', 5);
        if (token == 'undefined') {
            setrespuestaPay(true);
            setrespuestaPayStr(false);

        } else if (token == null) {
            setrespuestaPay(false);
        }
        else {
            setrespuestaPay(true);
            setrespuestaPayStr(true);
        }

    }, [newNit, newDv, newRazonSocial, newNombres, newApellidos, newCorreo, newTyC, newTdp]);


    const formValidation = () => {
        if (newNit.isEmpty() || newDv.isEmpty() || newRazonSocial.isEmpty() || newNombres.isEmpty() || newApellidos.isEmpty() || newCorreo.isEmpty() || newTyC == false || newTdp == false) {
            return true
        } else {
            return false
        }
    }

    String.prototype.isEmpty = function () {
        return (this.length === 0 || !this.trim());
    };

    const createUser = (e) => {
        e.preventDefault();
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));

        var raw = JSON.stringify({
            "NombreUsuario": localStorage.getItem('newNombres') + "" + localStorage.getItem('newApellidos'),
            "Correo": localStorage.getItem('newCorreo'),
            "NombreEmpresa": localStorage.getItem('newRazonSocial'),
            "NitEmpresa": localStorage.getItem('newNit'),
            "User": localStorage.getItem('newUser'),
            "Password": localStorage.getItem('newPass'),
            "DigitoVerificacion": localStorage.getItem('newDv'),
            "Celular": "1234567890",
            "IdPais": localStorage.getItem('newPais'),
            "IdDepartamento": localStorage.getItem('newDepartamento'),
            "IdMunicipio": localStorage.getItem('newMunicipio')
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("./api/User/registrarusuario", requestOptions)
            .then(response => response.json())
            .then(result => {
                //console.log(result);
                if (result.codResponse == 0) {
                    setOpen3(true);
                    setErrorShow2(result.messageResponse);
                } else {
                    setOpen4(true);
                    setErrorShow3(result.messageResponse);
                    setlogged(true);
                }


            })
            .catch(error => console.log('error', error));
    }

    const [IdPais, setIdPais] = React.useState(0);
    const handleIdPais = (e) => {
        setIdPais(e.target.value);
        selectDataDepartamentosLoad(e.target.value);
        //console.log(e.target.value);
        localStorage.setItem('newPais', e.target.value);
    }
    const [IdDepartamento, setIdDepartamento] = React.useState(0);
    const handleIdDepartamento = (e) => {
        setIdDepartamento(e.target.value);
        selectDataCiudadesLoad(e.target.value);
        localStorage.setItem('newDepartamento', e.target.value);
    }
    const [IdMunicipio, setIdMunicipio] = React.useState(0);
    const handleIdMunicipio = (e) => {
        setIdMunicipio(e.target.value);
        localStorage.setItem('newMunicipio', e.target.value);
    }

    const [dataPaisesLista, setDataPaises] = React.useState(dataPaises);
    const [dataDepartamentosLista, setDataDepts] = React.useState(dataDepartamentos);
    const [dataCiudadLista, setDataCiudades] = React.useState(dataCiudades);
    const selectDataPaisesLoad = () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        //myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        fetch("./api/Auxiliar/ListaPaises", requestOptions)
            .then(response => response.json())
            .then(result => {
                dataPaises = result.basePresentationList;
                //console.log(dataPaises);
                setDataPaises(dataPaises);
                setLoading(false);
            })
            .catch(error => console.log('error', error));
    }
    const selectDataDepartamentosLoad = (pais) => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));


        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        var url = "./api/Auxiliar/ListaDepartamentosPais?iIdPais=" + String(pais)

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                dataDepartamentos = result.basePresentationList;
                //console.log(dataDepartamentos);
                setDataDepts(dataDepartamentos);
            })
            .catch(error => console.log('error', error));
    }
    const selectDataCiudadesLoad = (ciudad) => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('token'));

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        var url = "./api/Auxiliar/ListaMuniciposDepartamento?iIdDepartamento=" + String(ciudad)

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => {
                dataCiudades = result.basePresentationList;
                //console.log(dataCiudades);
                setDataCiudades(dataCiudades);
            })
            .catch(error => console.log('error', error));
    }

    const [user, setUser] = React.useState("");
    const [password, setPassword] = React.useState("");


    const handleUser = (e) => {
        setUser(e.target.value);
    }

    const handlePass = (e) => {
        setPassword(e.target.value);
    }

    //new user
    const [cantidadDatosLlenos, setcantidadDatosLlenos] = React.useState(0);

    const [newUser, setnewUser] = React.useState("");
    const handleNewUser = (e) => {
        setnewUser(e.target.value);
        localStorage.setItem('newUser', e.target.value);
    }
    const [newPass, setnewPass] = React.useState("");
    const handleNewPass = (e) => {
        setnewPass(e.target.value);
        localStorage.setItem('newPass', e.target.value);
    }

    const [newPassR, setnewPassR] = React.useState("");
    const handleNewPassR = (e) => {
        setnewPassR(e.target.value);
        localStorage.setItem('newPassR', e.target.value);
    }


    const handleNewNit = (e) => {
        setnewNit(e.target.value);
        localStorage.setItem('newNit', e.target.value);

    }


    const handleNewDv = (e) => {
        setnewDv(e.target.value);
        localStorage.setItem('newDv', e.target.value);
    }

    const handleNewRazonSocial = (e) => {
        setnewRazonSocial(e.target.value);
        localStorage.setItem('newRazonSocial', e.target.value);
    }

    const handleNewNombres = (e) => {
        setnewNombres(e.target.value);
        localStorage.setItem('newNombres', e.target.value);
    }

    const handleNewApellidos = (e) => {
        setnewApellidos(e.target.value);
        localStorage.setItem('newApellidos', e.target.value);
    }

    const handleNewCorreo = (e) => {
        setnewCorreo(e.target.value);
        localStorage.setItem('newCorreo', e.target.value);
    }

    const handleNewTyC = (e) => {
        setnewTyC(e.target.checked);
        localStorage.setItem('newTyC', e.target.value)
    }

    const handleNewCupon = (e) => {
        setnewCupon(e.target.value);

        if (e.target.value === "AVesalarium") {
            setbasico("$138.600.00");
            setavanzado("$210.000.00");
            setbasicostr("138600");
            setavanzadostr("210000");
            settieneDescuento(true);
        } else {
            setbasico("198.000.00");
            setavanzado("$300.000.00");
            setbasicostr("198000");
            setavanzadostr("300000");
            settieneDescuento(false);
        }
    }

    const handleNewTdp = (e) => {
        setnewTdp(e.target.checked);
        localStorage.setItem('newTdp', e.target.value)
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        login(user, password)

        //window.location = '/admin/dashboard';
    }

    const [loading, setLoading] = React.useState(false);
    const [errorShow, setErrorShow] = React.useState("");
    const [open2, setOpen2] = React.useState(false);

    const [errorShow2, setErrorShow2] = React.useState("");
    const [open3, setOpen3] = React.useState(false);

    const [errorShow3, setErrorShow3] = React.useState("");
    const [open4, setOpen4] = React.useState(false);

    const [openRegistro, setOpenRegistro] = React.useState(false);

    const setRegistro = (e) => {
        e.preventDefault();
        setOpenRegistro(true);
    }

    const downloadFile = () => {

        window.open("https://localhost:44313/assets/img/ProcesodeInscripcionaHabilitacionNomina.pdf", "_blank");
        //window.open("https://docs.google.com/document/d/19bN2ueQBAAd0XWdFJlXvIf0soMteD6GBNpMBKpJ6aTo/edit#heading=h.btdn28y9llm", "_blank");
    }

    const login = (nombre, password) => {

        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({ "User": nombre, "Password": password });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        const apiUrl = './api/Login/autenticacion';
        fetch(apiUrl, requestOptions)
            .then(response => response.json())
            .then(

                data => {
                    var cod = data.codResponse;
                    if (cod === 1) {
                        //console.log(data)
                        localStorage.clear();
                        var id = data.basePresentation;
                        localStorage.setItem('idEmpresa', id.IdEmpresa);
                        localStorage.setItem('token', data.messageResponse);
                        localStorage.setItem('usuarioNombre', nombre);

                        //window.location = '/admin/icons';logged
                        setLoading(false);
                        setlogged(true);
                        setrespuestaPay(true);
                    }
                    else {
                        setErrorShow("Usuario o contraseña incorrectos.");
                        setUser("");
                        setPassword("");
                        setLoading(false);
                        setOpen2(true);
                    }

                }

            )
            .catch(error => {
                //console.log('error', error);
                setErrorShow(String(error));
                setLoading(false);
                setOpen2(true);
            }
            )
    }


    const toHome = () => {
        window.location = "/admin/user-profile";
    }

    return (
        <div style={{ backgroundImage: "url(" + imagenfondo + ")", height: "100%" }}>

            <Dialog open={loading} >
                <div style={{ textAlign: "center", margin: "15px" }}>
                    {loading && <Spinner color="secondary" />}
                    <h3 style={{ fontSize: '15px', fontFamily: 'Hammersmith One' }}>Cargando...</h3>
                </div>
            </Dialog>

            <Row style={{ height: "100%" }}>
                <Col md="1">
                </Col>
                <Col md="3" style={{ display: "flex", alignItems: "center" }} hidden={respuestaPay}>

                    <img src={animacion} alt="Logo" />
                </Col>
                <Col md="3" style={{ display: "flex", alignItems: "center" }} hidden={!respuestaPayStr || !respuestaPay || logged}>

                    <img src={ok} alt="Logo" />
                </Col>
                <Col md="3" style={{ display: "flex", alignItems: "center" }} hidden={respuestaPayStr || !respuestaPay || logged}>

                    <img src={nok} alt="Logo" />
                </Col>
                <Col md="3" style={{ display: "flex", alignItems: "center" }} hidden={!logged || !respuestaPay}>

                    <img src={animacion} alt="Logo" />
                </Col>
                <Col md="3" style={{ fontFamily: 'Hammersmith One', alignItems: "center", display: "flex" }} hidden={respuestaPay}>
                    <Col md="12">
                        <h3 style={{ textAlign: "center", fontSize: "45px", textAlign: "left" }}>Inicia en</h3>
                        <img src={logo} alt="Logo" style={{ marginTop: "-50px" }} />
                        <h5 style={{ textAlign: "center", fontSize: "15px", textAlign: "left", marginTop: "20px" }}>Herramienta de Nómina electrónica para las pequeñas empresas</h5>
                        {/*<h5 style={{ textAlign: "center", fontSize: "11px", textAlign: "left", marginTop: "30px" }}>¿No tienes cuenta?</h5>
                        <h5 style={{ textAlign: "center", fontSize: "11px", textAlign: "left", marginTop: "-15px" }}>Puedes crear una <a href={"/registro"}>aquí</a></h5>*/}

                        <h5 style={{ textAlign: "center", fontSize: "11px", textAlign: "left", marginTop: "30px" }}>Version 3.0.1</h5>
                    </Col>
                </Col>
                <Col md="3" style={{ fontFamily: 'Hammersmith One', alignItems: "center", display: "flex" }} hidden={!respuestaPayStr || !respuestaPay || logged}>
                    <Col md="12">

                        <h5 style={{ textAlign: "center", fontSize: "20px", textAlign: "left", marginTop: "20px" }}>Transacción confirmada</h5>
                        {/*<h5 style={{ textAlign: "center", fontSize: "11px", textAlign: "left", marginTop: "30px" }}>¿No tienes cuenta?</h5>
                        <h5 style={{ textAlign: "center", fontSize: "11px", textAlign: "left", marginTop: "-15px" }}>Puedes crear una <a href={"/registro"}>aquí</a></h5>*/}

                        <h5 style={{ textAlign: "center", fontSize: "13px", textAlign: "left", marginTop: "30px" }}>su transacción fue confirmada, ingresa un usuario y contraseña para finalizar el proceso.</h5>
                    </Col>
                </Col>
                <Col md="3" style={{ fontFamily: 'Hammersmith One', alignItems: "center", display: "flex" }} hidden={respuestaPayStr || !respuestaPay || logged}>
                    <Col md="12">

                        <h5 style={{ textAlign: "center", fontSize: "20px", textAlign: "left", marginTop: "20px" }}>Transacción Rechazada</h5>
                        {/*<h5 style={{ textAlign: "center", fontSize: "11px", textAlign: "left", marginTop: "30px" }}>¿No tienes cuenta?</h5>
                        <h5 style={{ textAlign: "center", fontSize: "11px", textAlign: "left", marginTop: "-15px" }}>Puedes crear una <a href={"/registro"}>aquí</a></h5>*/}

                        <h5 style={{ textAlign: "center", fontSize: "13px", textAlign: "left", marginTop: "30px" }}>su transacción no fue confirmada, hubo un error al confirmar.</h5>
                    </Col>
                </Col>

                <Col md="3" style={{ fontFamily: 'Hammersmith One', alignItems: "center", display: "flex" }} hidden={!logged || !respuestaPay}>
                    <Col md="12">
                        <h3 style={{ textAlign: "center", fontSize: "45px", textAlign: "left" }}>Bienvenido a</h3>
                        <img src={logo} alt="Logo" style={{ marginTop: "-50px" }} />
                        <h5 style={{ textAlign: "center", fontSize: "15px", textAlign: "left", marginTop: "20px" }}>Herramienta de Nómina electrónica para las pequeñas empresas</h5>
                        {/*<h5 style={{ textAlign: "center", fontSize: "11px", textAlign: "left", marginTop: "30px" }}>¿No tienes cuenta?</h5>
                        <h5 style={{ textAlign: "center", fontSize: "11px", textAlign: "left", marginTop: "-15px" }}>Puedes crear una <a href={"/registro"}>aquí</a></h5>*/}

                        <h5 style={{ textAlign: "center", fontSize: "13px", textAlign: "left", marginTop: "30px" }}>mira el video y descarga el instructivo para la habilitación</h5>
                    </Col>
                </Col>

                <Col md="4" style={{ display: "flex", alignItems: "center" }} hidden={!respuestaPayStr || !respuestaPay || logged}>
                    <Col md="12">


                        <Form hidden={openRegistro} style={{ margin: "50px" }} method={'POST'}>
                            <Label for="exampleEmail" style={{ fontSize: "15px", fontFamily: 'Hammersmith One' }}>Crear Nuevo Usuario</Label>
                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Usuario o numero de telefono</Label>
                                <Input type="email" name="email" id="exampleEmail" onChange={handleNewUser} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Usuario" />
                            </FormGroup>
                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Contraseña</Label>
                                <Input type="password" name="email" id="exampleEmail" onChange={handleNewPass} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="contraseña" />
                            </FormGroup>
                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Confirmar contraseña</Label>
                                <Input type="password" name="pa" id="exampleEmail" onChange={handleNewPassR} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="contraseña" />
                            </FormGroup>
                            <Button variant="primary" onClick={createUser} style={{
                                fontFamily: 'Hammersmith One', backgroundColor: "#1aa2e0", borderColor: "#1aa2e0", background: "#1aa2e0",
                                backgroundImage: "linear-gradient(to bottom left, #1aa2e0, #1aa2e0, #1aa2e0)", marginTop: "20px", width: "100%"
                            }}>Crear Cuenta</Button>
                            <Collapse in={open3}>
                                <Alert severity="error" onClose={() => { setOpen3(false); }}>
                                    <AlertTitle>Error</AlertTitle>
                                    {errorShow2}
                                </Alert>
                            </Collapse>
                            <Collapse in={open4}>
                                <Alert severity="success" onClose={() => { setOpen4(false); }}>
                                    <AlertTitle>Información</AlertTitle>
                                    {errorShow3}
                                </Alert>
                            </Collapse>
                            <hr style={{ color: "#000000", height: "6", marginTop: "20px" }}>
                            </hr>

                        </Form>

                    </Col>
                </Col>



                <Col md="4" style={{ display: "flex", alignItems: "center" }} hidden={!logged || !respuestaPay}>
                    <Col md="12">
                        <div hidden={imageView}>
                            <Lightbox

                                medium={infografia}
                                large={infografia}
                                alt="Instructivo para Habilitación"
                                onClose={() => { setImageView(true); }}
                            />
                        </div>
                        
                        {/*<img src={infografia} alt="this is car image" />*/}
                        <iframe width="400" height="250" src="https://www.youtube.com/embed/YseZ6JtpYpY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                        <Row>
                            <Col md="6">
                                <Button variant="primary" style={{
                                    fontFamily: 'Hammersmith One', backgroundColor: "#000000", borderColor: "#1aa2e0", background: "#ffffff",
                                    marginTop: "0px", width: "100%"
                                }}><AiFillFilePdf style={{ color: "#000000" }} /><Link to="/files/ProcesodeInscripcionaHabilitacionNomina.pdf" target="_blank" download>Ver Instructivo</Link></Button>
                            </Col>
                            <Col md="6">
                                <Button variant="secondary" style={{
                                    fontFamily: 'Hammersmith One', backgroundColor: "#1aa2e0", borderColor: "#1aa2e0", background: "#1aa2e0",
                                    backgroundImage: "linear-gradient(to bottom left, #1aa2e0, #1aa2e0, #1aa2e0)", marginTop: "0px", width: "100%"
                                }} onClick={() => { setImageView(false); }}>Ver Pasos para habilitación</Button>
                            </Col>

                        </Row>

                        
                        
                        <Button variant="primary" style={{
                            fontFamily: 'Hammersmith One', backgroundColor: "#1aa2e0", borderColor: "#1aa2e0", background: "#1aa2e0",
                            marginTop: "0px", width: "100%", color:"#ffffff"
                        }} onClick={toHome}>Configurar SetTestId</Button>
                    </Col>
                </Col>

                <Col md="4" style={{ display: "flex", alignItems: "center" }} hidden={respuestaPay}>
                    <Col md="12">
                        <Form hidden={openRegistro} style={{ margin: "50px" }} method={'POST'}>
                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Usuario o numero de telefono</Label>
                                <Input type="email" name="email" id="exampleEmail" onChange={handleUser} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Usuario" />
                            </FormGroup>
                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Contraseña</Label>
                                <Input type="password" name="email" id="exampleEmail" onChange={handlePass} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="contraseña" />
                            </FormGroup>
                            <h5 style={{ textAlign: "right", fontSize: "11px", textAlign: "right", fontFamily: 'Hammersmith One' }}><a href={"/registro"}>Recuperar Contraseña</a></h5>
                            <Button variant="primary" onClick={handleSubmit} style={{
                                fontFamily: 'Hammersmith One', backgroundColor: "#1aa2e0", borderColor: "#1aa2e0", background: "#1aa2e0",
                                backgroundImage: "linear-gradient(to bottom left, #1aa2e0, #1aa2e0, #1aa2e0)", marginTop: "20px", width: "100%"
                            }}>Iniciar Sesión</Button>
                            <Collapse in={open2}>
                                <Alert severity="error" onClose={() => { setOpen2(false); }}>
                                    <AlertTitle>Error</AlertTitle>
                                    {errorShow}
                                </Alert>
                            </Collapse>
                            <hr style={{ color: "#000000", height: "6", marginTop: "20px" }}>
                            </hr>
                            <Col md="12" style={{ display: "flex", alignItems: "center" }}>
                                <h5 style={{ textAlign: "center", fontSize: "14px", textAlign: "left", marginTop: "5px", fontFamily: 'Hammersmith One' }}>¿No tienes cuenta?</h5>
                            </Col>
                            <Col md="12" style={{ display: "flex", alignItems: "center" }}>
                                {/*<GoogleButton
                                    type="light"
                                    style={{ fontFamily: 'Hammersmith One', borderRadius: "10px", width: "100%", fontSize: "12px" }}
                                    onClick={() => { //console.log('Google button clicked') }}
                                />*/}

                                <Button variant="primary" onClick={setRegistro} style={{
                                    fontFamily: 'Hammersmith One', backgroundColor: "#1aa2e0", borderColor: "#1aa2e0", background: "#1aa2e0",
                                    backgroundImage: "linear-gradient(to bottom left, #1aa2e0, #1aa2e0, #1aa2e0)", marginTop: "0px", width: "100%"
                                }}>Empezar Aquí</Button>
                            </Col>
                        </Form>
                        <Form hidden={!openRegistro} style={{ margin: "50px" }} method={'POST'}>
                            <FormGroup>
                                <Alert color="primary" isOpen={true}>
                                    Todos los campos son obligatorios a excepción del campo cupón.
                                    Se habilitará el boton de pago cuando esten completos.
                                </Alert>
                            </FormGroup>
                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Nit</Label>
                                <Input type="number" name="email" id="exampleEmail" value={newNit} onChange={handleNewNit} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="900000000" />
                                <FormFeedback tooltip>
                                    Oh noes! that name is already taken
                                </FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Digito Verificación</Label>
                                <Input type="number" name="email" id="exampleEmail" value={newDv} onChange={handleNewDv} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="1" />
                            </FormGroup>
                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Razón Social</Label>
                                <Input type="text" name="email" id="exampleEmail" value={newRazonSocial} onChange={handleNewRazonSocial} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Razon Social" />
                            </FormGroup>
                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Nombres</Label>
                                <Input type="text" name="email" id="exampleEmail" value={newNombres} onChange={handleNewNombres} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Nombre" />
                            </FormGroup>
                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Apellidos</Label>
                                <Input type="text" name="email" id="exampleEmail" value={newApellidos} onChange={handleNewApellidos} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Apellidos" />
                            </FormGroup>
                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Correo</Label>
                                <Input type="email" name="email" id="exampleEmail" value={newCorreo} onChange={handleNewCorreo} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Correo@correo.com" />
                            </FormGroup>
                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Cupón</Label>
                                <Input type="text" name="pa" id="exampleEmail" onChange={handleNewCupon} value={newCupon} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }} placeholder="Ingrese el cupón" />
                            </FormGroup>

                            <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>País</Label>
                            <Input type="select" name="select" id="exampleSelect" onChange={handleIdPais} defaultValue={IdPais} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }}>
                                {dataPaisesLista.map((tipo, index) =>
                                    <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                            </Input>

                            

                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Departamento</Label>
                                <Input type="select" name="select" id="exampleSelect" onChange={handleIdDepartamento} defaultValue={IdDepartamento} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }}>
                                    {dataDepartamentosLista.map((tipo, index) =>
                                        <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                                </Input>
                            </FormGroup>

                            <FormGroup>
                                <Label for="exampleEmail" style={{ fontSize: "12px", fontFamily: 'Hammersmith One' }}>Municipio</Label>
                                <Input type="select" name="select" id="exampleSelect" onChange={handleIdMunicipio} defaultValue={IdMunicipio} style={{ background: "#FFFFFF", border: "none", fontFamily: 'Hammersmith One' }}>
                                    {dataCiudadLista.map((tipo, index) =>
                                        <option key={index} value={tipo.Codigo}>{tipo.Descripcion}</option>)}
                                </Input>
                            </FormGroup>

                           

                            <FormGroup>

                                <Row>
                                    <Col md="2">
                                        <input
                                            name="tyc"
                                            type="checkbox"
                                            onChange={handleNewTyC} checked={newTyC} />
                                    </Col>
                                    <Col md="9">
                                        <Label style={{ marginLeft: "-25px", fontFamily: 'Hammersmith One' }}>Acepta Terminos y Condiciones</Label>
                                    </Col>

                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col md="2">
                                        <input
                                            name="apr"
                                            type="checkbox"
                                            onChange={handleNewTdp} checked={newTdp} />
                                    </Col>
                                    <Col md="9">
                                        <Label style={{ marginLeft: "-25px", fontFamily: 'Hammersmith One' }}>Acepta Tratamiento de datos personales</Label>
                                    </Col>

                                </Row>

                            </FormGroup>
                            <div hidden={ocultaBotones || tieneDescuento}>
                                <FormGroup>
                                    <Row style={{ marginTop: "35px" }}>
                                        <Col md="4">
                                            <Label for="exampleEmail" style={{ fontSize: "14px", fontFamily: 'Hammersmith One', marginTop: "10px" }}>{"Plan Básico (" + basico + "):"}</Label>
                                        </Col>
                                        <Col md="7">

                                            <form method='POST' >
                                                <ScriptTag isHydrating={true} type="text/javascript" src='https://checkout.epayco.co/checkout.js' data-epayco-key='b48baf9bf76273ea2aa4e6185f4e4377'
                                                    class='epayco-button'
                                                    data-epayco-amount='198000'
                                                    data-epayco-tax='0'
                                                    data-epayco-tax-ico='0'
                                                    data-epayco-tax-base='198000'
                                                    data-epayco-name='eSalarium Basico (10 comprobantes mensuales)'
                                                    data-epayco-description='eSalarium Basico (10 comprobantes mensuales)'
                                                    data-epayco-currency='cop'
                                                    data-epayco-country='CO'
                                                    data-epayco-test='false'
                                                    data-epayco-external='false'
                                                    data-epayco-response={apiRoot}
                                                    data-epayco-rejected={apiRoot}
                                                    data-epayco-pending={apiRoot}
                                                    data-epayco-confirmation={apiRoot}
                                                    data-epayco-button='https://multimedia.epayco.co/dashboard/btns/btn7.png' />
                                            </form>
                                        </Col>
                                    </Row>
                                </FormGroup>

                                <FormGroup >
                                    <Row>
                                        <Col md="4">
                                            <Label for="exampleEmail" style={{ fontSize: "14px", fontFamily: 'Hammersmith One' }}>{"Plan Avanzado (" + avanzado + "):"}</Label>
                                        </Col>
                                        <Col md="7">
                                            <ScriptTag isHydrating={true} type="text/javascript" src='https://checkout.epayco.co/checkout.js'
                                                data-epayco-key='b48baf9bf76273ea2aa4e6185f4e4377'
                                                class='epayco-button'
                                                data-epayco-amount='300000'
                                                data-epayco-tax='0'
                                                data-epayco-tax-ico='0'
                                                data-epayco-tax-base='300000'
                                                data-epayco-name='eSalarium Avanzado (20 comprobantes)'
                                                data-epayco-description='eSalarium Avanzado (20 comprobantes)'
                                                data-epayco-currency='cop'
                                                data-epayco-country='CO'
                                                data-epayco-test='false'
                                                data-epayco-external='false'
                                                data-epayco-response={apiRoot}
                                                data-epayco-rejected={apiRoot}
                                                data-epayco-pending={apiRoot}
                                                data-epayco-confirmation={apiRoot}
                                                data-epayco-button='https://multimedia.epayco.co/dashboard/btns/btn7.png' />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </div>
                            <div hidden={ocultaBotones || !tieneDescuento}>
                                Roberto
                                <FormGroup>
                                    <Row style={{ marginTop: "35px" }}>
                                        <Col md="4">
                                            <Label for="exampleEmail" style={{ fontSize: "14px", fontFamily: 'Hammersmith One', marginTop: "10px" }}>{"Plan Básico (" + basico + "):"}</Label>
                                        </Col>
                                        <Col md="7">

                                            <form method='POST' >
                                                <ScriptTag isHydrating={true} type="text/javascript" src='https://checkout.epayco.co/checkout.js' data-epayco-key='b48baf9bf76273ea2aa4e6185f4e4377'
                                                    class='epayco-button'
                                                    data-epayco-amount='138600'
                                                    data-epayco-tax='0'
                                                    data-epayco-tax-ico='0'
                                                    data-epayco-tax-base='138600'
                                                    data-epayco-name='eSalarium Basico (10 comprobantes mensuales)'
                                                    data-epayco-description='eSalarium Basico (10 comprobantes mensuales)'
                                                    data-epayco-currency='cop'
                                                    data-epayco-country='CO'
                                                    data-epayco-test='false'
                                                    data-epayco-external='false'
                                                    data-epayco-response={apiRoot}
                                                    data-epayco-rejected={apiRoot}
                                                    data-epayco-pending={apiRoot}
                                                    data-epayco-confirmation={apiRoot}
                                                    data-epayco-button='https://multimedia.epayco.co/dashboard/btns/btn7.png' />
                                            </form>
                                        </Col>
                                    </Row>
                                </FormGroup>

                                <FormGroup >
                                    <Row>
                                        <Col md="4">
                                            <Label for="exampleEmail" style={{ fontSize: "14px", fontFamily: 'Hammersmith One' }}>{"Plan Avanzado (" + avanzado + "):"}</Label>
                                        </Col>
                                        <Col md="7">
                                            <ScriptTag isHydrating={true} type="text/javascript" src='https://checkout.epayco.co/checkout.js'
                                                data-epayco-key='b48baf9bf76273ea2aa4e6185f4e4377'
                                                class='epayco-button'
                                                data-epayco-amount='210000'
                                                data-epayco-tax='0'
                                                data-epayco-tax-ico='0'
                                                data-epayco-tax-base='210000'
                                                data-epayco-name='eSalarium Avanzado (20 comprobantes)'
                                                data-epayco-description='eSalarium Avanzado (20 comprobantes)'
                                                data-epayco-currency='cop'
                                                data-epayco-country='CO'
                                                data-epayco-test='false'
                                                data-epayco-external='false'
                                                data-epayco-response={apiRoot}
                                                data-epayco-rejected={apiRoot}
                                                data-epayco-pending={apiRoot}
                                                data-epayco-confirmation={apiRoot}
                                                data-epayco-button='https://multimedia.epayco.co/dashboard/btns/btn7.png' />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </div>
                        </Form>
                    </Col>
                </Col>
            </Row>

        </div>
    );
}